import { render } from "./tipoopera-editar.vue?vue&type=template&id=7cdc3b1a"
import script from "./tipoopera-editar.vue?vue&type=script&lang=js"
export * from "./tipoopera-editar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__